import { render, staticRenderFns } from "./ModalDeleteBlocked.vue?vue&type=template&id=b2fd116a&"
import script from "./ModalDeleteBlocked.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports